import React, { useState, useEffect, useRef } from "react";
import {
  MessageSquare,
  Send,
  Upload,
  File,
  Eye,
  Download,
  Reply,
  Paperclip,
  X,
  Search,
  Filter,
  HelpCircle,
  Type,
  Plus,
  Trash2,
  Loader,
  User,
  Clock,
  CheckCircle,
  AlertTriangle,
  Image,
  Calendar,
  FileText,
  Check,
  ChevronDown,
  ChevronUp
} from "lucide-react";

// Import your discussion service
import {
  getApplicationDiscussions,
  sendDiscussionMessage,
  markMessagesAsRead,
  uploadDiscussionDocument,
  subscribeToApplicationUpdates,
  submitQuestionAnswer,
} from "../../services/discussionService"; // Adjust path as needed
import { getQueriesByFilter } from "../../services/queryService";
import { useAuth } from "../../context/AuthContext";
import { auth } from "../../services/firebaseConfig";



// const DiscussionComponent = ({ 
//   applicationId = "app123", // Default for demo
//   onDiscussionUpdate
// }) => {
//   const { userData } = useAuth();
//   const currentUser = {...userData, uid: auth?.currentUser?.uid} || {}; // Fallback to empty object if userData is not available
//   const messagesEndRef = useRef(null);
//   const fileInputRef = useRef(null);
//   const chatContainerRef = useRef(null);

//   // Main state
//   const [messages, setMessages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [newMessage, setNewMessage] = useState("");
//   const [messageType, setMessageType] = useState("text");
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [replyingTo, setReplyingTo] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterUser, setFilterUser] = useState("all");
//   const [actionLoading, setActionLoading] = useState({});
//   const [unreadCount, setUnreadCount] = useState(0);

//   // Q&A Form state
//   const [showQnAForm, setShowQnAForm] = useState(false);
//   const [qnaQuestions, setQnaQuestions] = useState([]);
//   const [newQuestion, setNewQuestion] = useState({
//     question: "",
//     required: false,
//     answerType: "text",
//     description: "",
//   });

//   // Answer state
//   const [answeringQuestion, setAnsweringQuestion] = useState(null);
//   const [questionAnswers, setQuestionAnswers] = useState({});
//   const [expandedAnswers, setExpandedAnswers] = useState({});

//   // Standard queries autocomplete state
//   const [standardQueries, setStandardQueries] = useState([]);
//   const [filteredQueries, setFilteredQueries] = useState([]);
//   const [showAutocomplete, setShowAutocomplete] = useState(false);
//   const [autocompleteLoading, setAutocompleteLoading] = useState(false);
//   const autocompleteRef = useRef(null);

//   // Load messages and set up real-time listener
//   useEffect(() => {
//     console.log('Setting up discussion component for application:', applicationId);
    
//     // Initial load
//     loadMessages();

//     // Set up real-time listener
//     const unsubscribe = subscribeToApplicationUpdates(
//       applicationId,
//       (updatedData) => {
//         console.log('Received real-time update:', updatedData);
        
//         if (updatedData.error) {
//           console.error('Real-time listener error:', updatedData.error);
//           return;
//         }
        
//         if (updatedData.discussionMessages) {
//           console.log('Updating messages from real-time listener:', updatedData.discussionMessages.length);
//           setMessages(updatedData.discussionMessages);
//           calculateUnreadMessages(updatedData.discussionMessages);
//         }
//       }
//     );

//     // Mark messages as read when component mounts
//     setTimeout(() => {
//       markAllMessagesAsRead();
//     }, 1000);

//     return () => {
//       console.log('Cleaning up real-time listener');
//       if (unsubscribe) {
//         unsubscribe();
//       }
//     };
//   }, [applicationId, currentUser?.uid]);

//   // Auto scroll to bottom when new messages arrive
//   useEffect(() => {
//     scrollToBottom();
//   }, [messages]);

//   // Debug effect to log state changes
//   useEffect(() => {
//     console.log('Messages state updated, count:', messages.length);
//     if (messages.length > 0) {
//       const qnaMessages = messages.filter(m => m.qnaQuestions?.length > 0);
//       console.log('Q&A messages found:', qnaMessages.length);
//       qnaMessages.forEach(msg => {
//         console.log('Q&A Message:', msg.id, 'Questions:', msg.qnaQuestions?.length);
//         msg.qnaQuestions?.forEach(q => {
//           console.log('Question:', q.id, 'Answers:', q.answers?.length);
//           q.answers?.forEach(a => {
//             console.log('Answer by:', a.respondentName, 'ID:', a.respondentId);
//           });
//         });
//       });
//     }
//   }, [messages]);

//   // Notify parent component of unread count changes
//   useEffect(() => {
//     if (onDiscussionUpdate) {
//       onDiscussionUpdate(unreadCount);
//     }
//   }, [unreadCount, onDiscussionUpdate]);

//   const loadMessages = async () => {
//     setLoading(true);
//     try {
//       console.log('Loading messages for application:', applicationId);
//       const result = await getApplicationDiscussions(applicationId);
      
//       if (result.success) {
//         console.log('Loaded messages:', result.discussions.length);
        
//         // Sort messages by timestamp
//         const sortedMessages = result.discussions.sort((a, b) => {
//           const timeA = a.timestamp?.getTime ? a.timestamp.getTime() : 
//                        a.timestamp?.toDate ? a.timestamp.toDate().getTime() : 
//                        new Date(a.createdAt || 0).getTime();
//           const timeB = b.timestamp?.getTime ? b.timestamp.getTime() : 
//                        b.timestamp?.toDate ? b.timestamp.toDate().getTime() : 
//                        new Date(b.createdAt || 0).getTime();
//           return timeA - timeB;
//         });
        
//         setMessages(sortedMessages);
//         calculateUnreadMessages(sortedMessages);
//       } else {
//         console.error("Error loading messages:", result.error);
//         setMessages([]); // Set empty array on error
//       }
//     } catch (error) {
//       console.error("Error loading messages:", error);
//       setMessages([]); // Set empty array on error
//     } finally {
//       setLoading(false);
//     }
//   };

//   const calculateUnreadMessages = (messageList) => {
//     if (!messageList || !currentUser?.uid) return;

//     let unread = 0;
//     messageList.forEach((message) => {
//       if (!message.readBy?.includes(currentUser.uid) && message.sender !== currentUser.uid) {
//         unread++;
//       }
//     });
//     setUnreadCount(unread);
//   };

//   const markAllMessagesAsRead = async () => {
//     if (!currentUser?.uid) return;
//     try {
//       await markMessagesAsRead(applicationId, currentUser.uid);
//       setUnreadCount(0);
//     } catch (error) {
//       console.error("Error marking messages as read:", error);
//     }
//   };

//   const scrollToBottom = () => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   };

//   const formatDate = (timestamp) => {
//     if (!timestamp) return "N/A";
    
//     let date;
//     if (timestamp.toDate) {
//       // Firestore timestamp
//       date = timestamp.toDate();
//     } else if (timestamp instanceof Date) {
//       // Regular Date object
//       date = timestamp;
//     } else if (typeof timestamp === 'string') {
//       // ISO string
//       date = new Date(timestamp);
//     } else {
//       // Fallback
//       date = new Date();
//     }
    
//     return date.toLocaleDateString("en-IN", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   const formatTime = (timestamp) => {
//     if (!timestamp) return "";
    
//     let date;
//     if (timestamp.toDate) {
//       date = timestamp.toDate();
//     } else if (timestamp instanceof Date) {
//       date = timestamp;
//     } else if (typeof timestamp === 'string') {
//       date = new Date(timestamp);
//     } else {
//       date = new Date();
//     }
    
//     return date.toLocaleTimeString("en-IN", {
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   const getUserRoleColor = (role) => {
//     const colors = {
//       Hospital: "bg-blue-500",
//       Doctor: "bg-green-500",
//       PolicyWriter: "bg-purple-500",
//       SuperAdmin: "bg-red-500",
//       Patient: "bg-orange-500",
//       default: "bg-gray-500"
//     };
//     return colors[role] || colors.default;
//   };

//   const getUserRoleBadge = (role) => {
//     const colors = {
//       Hospital: "bg-blue-100 text-blue-800 border-blue-200",
//       Doctor: "bg-green-100 text-green-800 border-green-200",
//       PolicyWriter: "bg-purple-100 text-purple-800 border-purple-200",
//       SuperAdmin: "bg-red-100 text-red-800 border-red-200",
//       Patient: "bg-orange-100 text-orange-800 border-orange-200"
//     };
    
//     return colors[role] || "bg-gray-100 text-gray-800 border-gray-200";
//   };

//   // File handling
//   const handleFileSelect = (event) => {
//     const files = Array.from(event.target.files);
//     if (files.length > 0) {
//       setSelectedFiles((prev) => [...prev, ...files]);
//     }
//   };

//   const removeSelectedFile = (index) => {
//     setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
//   };

//   // Q&A Form handling
//   const handleAddQuestion = () => {
//     if (!newQuestion.question.trim()) return;

//     const questionWithId = {
//       ...newQuestion,
//       id: `q_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
//     };

//     setQnaQuestions((prev) => [...prev, questionWithId]);
//     setNewQuestion({
//       question: "",
//       required: false,
//       answerType: "text",
//       description: "",
//     });
//   };

//   const removeQuestion = (questionId) => {
//     setQnaQuestions((prev) => prev.filter((q) => q.id !== questionId));
//   };

//   // Send message
//   const handleSendMessage = async () => {
//     if (messageType === "text" && !newMessage.trim()) return;
//     if (messageType === "file" && selectedFiles.length === 0) return;
//     if (messageType === "qna" && qnaQuestions.length === 0) return;

//     setActionLoading((prev) => ({ ...prev, sendMessage: true }));
    
//     try {
//       console.log('Sending message of type:', messageType);
      
//       let messageData = {
//         message: newMessage || "",
//         sender: currentUser?.uid,
//         senderName: currentUser.profile?.name || currentUser.email,
//         senderRole: currentUser.role,
//         messageType: messageType,
//         readBy: [currentUser?.uid],
//         replyTo: replyingTo?.id || null,
//       };

//       // Handle Q&A type message
//       if (messageType === "qna") {
//         messageData.qnaQuestions = qnaQuestions.map(q => ({
//           ...q,
//           answers: []
//         }));
//         messageData.message = `📋 Q&A Form: ${qnaQuestions.length} question${qnaQuestions.length > 1 ? 's' : ''}`;
//       }

//       // Upload files if any
//       if (selectedFiles.length > 0) {
//         console.log('Uploading files:', selectedFiles.length);
//         setActionLoading((prev) => ({ ...prev, uploadingFiles: true }));
        
//         const uploadPromises = selectedFiles.map((file) =>
//           uploadDiscussionDocument(applicationId, file, {
//             uploadedBy: currentUser?.uid,
//             uploaderName: currentUser.profile?.name || currentUser.email,
//           })
//         );

//         const uploadResults = await Promise.all(uploadPromises);
//         const attachments = uploadResults
//           .filter((result) => result.success)
//           .map((result) => result.document);

//         messageData.attachments = attachments;
//         console.log('Files uploaded successfully:', attachments.length);
//         setActionLoading((prev) => ({ ...prev, uploadingFiles: false }));
//       }

//       console.log('Sending message data:', messageData);
//       const result = await sendDiscussionMessage(applicationId, messageData);

//       if (result.success) {
//         console.log('Message sent successfully:', result.messageId);
        
//         // Reset form
//         setNewMessage("");
//         setSelectedFiles([]);
//         setReplyingTo(null);
//         setQnaQuestions([]);
//         setShowQnAForm(false);
//         setMessageType("text");
        
//         // Note: Don't reload messages manually, let the real-time listener handle it
//         console.log('Message form reset, waiting for real-time update...');
//       } else {
//         throw new Error(result.error);
//       }
//     } catch (error) {
//       console.error("Error sending message:", error);
//       alert("Failed to send message: " + error.message);
//     } finally {
//       setActionLoading((prev) => ({ 
//         ...prev, 
//         sendMessage: false, 
//         uploadingFiles: false 
//       }));
//     }
//   };

//   // Q&A Answer handling
//   const handleSubmitAnswer = async (questionId, messageId) => {
//     const answer = questionAnswers[questionId];
//     if (!answer?.text?.trim() && !answer?.files?.length) return;

//     setActionLoading((prev) => ({ ...prev, [`answer_${questionId}`]: true }));
    
//     try {
//       console.log('Submitting answer for question:', questionId, 'message:', messageId);
      
//       let answerData = {
//         questionId,
//         messageId, // This should be the Firestore document ID
//         answerText: answer.text || "",
//         respondentId: currentUser?.uid,
//         respondentName: currentUser.profile?.name || currentUser.email,
//         respondentRole: currentUser.role,
//       };

//       // Upload answer files if any
//       if (answer.files && answer.files.length > 0) {
//         console.log('Uploading answer files:', answer.files.length);
//         const uploadPromises = answer.files.map((file) =>
//           uploadDiscussionDocument(applicationId, file, {
//             uploadedBy: currentUser?.uid,
//             uploaderName: currentUser.profile?.name || currentUser.email,
//             questionId: questionId,
//           })
//         );

//         const uploadResults = await Promise.all(uploadPromises);
//         const attachments = uploadResults
//           .filter((result) => result.success)
//           .map((result) => result.document);

//         answerData.attachments = attachments;
//         console.log('Answer files uploaded successfully:', attachments.length);
//       }

//       const result = await submitQuestionAnswer(applicationId, answerData);
      
//       if (result.success) {
//         console.log('Answer submitted successfully');
        
//         // Clear the answer from state
//         setQuestionAnswers((prev) => ({
//           ...prev,
//           [questionId]: { text: "", files: [] }
//         }));
        
//         setAnsweringQuestion(null);
        
//         // Note: Don't reload messages manually, let the real-time listener handle it
//         console.log('Answer submitted, waiting for real-time update...');
//       } else {
//         throw new Error(result.error);
//       }
//     } catch (error) {
//       console.error("Error submitting answer:", error);
//       alert("Failed to submit answer: " + error.message);
//     } finally {
//       setActionLoading((prev) => ({ ...prev, [`answer_${questionId}`]: false }));
//     }
//   };

//   // Answer input handlers
//   const handleAnswerChange = (questionId, text) => {
//     setQuestionAnswers((prev) => ({
//       ...prev,
//       [questionId]: {
//         ...prev[questionId],
//         text: text,
//         files: prev[questionId]?.files || []
//       }
//     }));
//   };

//   const handleAnswerFileSelect = (questionId, event) => {
//     const files = Array.from(event.target.files);
//     setQuestionAnswers((prev) => ({
//       ...prev,
//       [questionId]: {
//         ...prev[questionId],
//         text: prev[questionId]?.text || "",
//         files: [...(prev[questionId]?.files || []), ...files]
//       }
//     }));
//   };

//   const removeAnswerFile = (questionId, fileIndex) => {
//     setQuestionAnswers((prev) => ({
//       ...prev,
//       [questionId]: {
//         ...prev[questionId],
//         files: prev[questionId]?.files?.filter((_, i) => i !== fileIndex) || []
//       }
//     }));
//   };

//   // Message filtering
//   const filterMessages = (messageList) => {
//     return messageList.filter((message) => {
//       const matchesSearch =
//         message.message?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         message.senderName?.toLowerCase().includes(searchTerm.toLowerCase());

//       const matchesUser =
//         filterUser === "all" || message.senderRole === filterUser;

//       return matchesSearch && matchesUser;
//     });
//   };

//   // Standard queries functions
//   const searchStandardQueries = async (searchTerm) => {
//     if (!searchTerm.trim() || searchTerm.length < 2) {
//       setFilteredQueries([]);
//       setShowAutocomplete(false);
//       return;
//     }

//     try {
//       setAutocompleteLoading(true);
//       const result = await getQueriesByFilter({
//         searchTerm: searchTerm,
//         limitCount: 10
//       });

//       if (result.success) {
//         setFilteredQueries(result.queries);
//         setShowAutocomplete(result.queries.length > 0);
//       }
//     } catch (error) {
//       console.error('Error searching standard queries:', error);
//       setFilteredQueries([]);
//       setShowAutocomplete(false);
//     } finally {
//       setAutocompleteLoading(false);
//     }
//   };

//   const selectStandardQuery = (query) => {
//     setNewMessage(query.queryDescription);
//     setShowAutocomplete(false);
//     setFilteredQueries([]);
//   };

//   const handleMessageChange = (e) => {
//     const value = e.target.value;
//     setNewMessage(value);
    
//     // Trigger search for standard queries
//     searchStandardQueries(value);
//   };

//   // Close autocomplete when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (autocompleteRef.current && !autocompleteRef.current.contains(event.target)) {
//         setShowAutocomplete(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   // Document handling
//   const openDocument = (document) => {
//     window.open(document.url, "_blank");
//   };

//   // Toggle answer expansion
//   const toggleAnswerExpansion = (questionId) => {
//     setExpandedAnswers(prev => ({
//       ...prev,
//       [questionId]: !prev[questionId]
//     }));
//   };

//   const filteredMessages = filterMessages(messages);

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center py-8">
//         <Loader className="h-6 w-6 animate-spin text-teal-500" />
//         <span className="ml-2 text-gray-600">Loading chat...</span>
//       </div>
//     );
//   }

//   return (
//     <div className="flex flex-col h-full max-h-screen bg-white rounded-lg border border-gray-200 shadow-sm">
//       {/* Debug Panel - Remove in production */}
//       {process.env.NODE_ENV === 'development' && (
//         <div className="bg-yellow-50 border-b border-yellow-200 p-2 text-xs">
//           <strong>Debug Info:</strong> Messages: {messages.length} | 
//           Q&A Messages: {messages.filter(m => m.qnaQuestions?.length > 0).length} | 
//           Current User: {currentUser?.profile?.name} ({currentUser?.uid}) | 
//           App ID: {applicationId}
//         </div>
//       )}
      
//       {/* Chat Header */}
//       <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gradient-to-r from-teal-50 to-blue-50">
//         <div className="flex items-center space-x-3">
//           <div className="p-2 bg-teal-100 rounded-lg">
//             <MessageSquare className="h-5 w-5 text-teal-600" />
//           </div>
//           <div>
//             <h2 className="text-lg font-semibold text-gray-900">
//               Application Discussion
//             </h2>
//             <p className="text-sm text-gray-600">
//               {filteredMessages.length} message{filteredMessages.length !== 1 ? 's' : ''}
//               {unreadCount > 0 && (
//                 <span className="ml-2 px-2 py-1 bg-red-100 text-red-800 text-xs rounded-full">
//                   {unreadCount} unread
//                 </span>
//               )}
//             </p>
//           </div>
//         </div>

//         <div className="flex items-center space-x-3">
//           {/* Search */}
//           <div className="relative">
//             <Search className="h-4 w-4 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
//             <input
//               type="text"
//               placeholder="Search messages..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="pl-9 pr-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500 w-48"
//             />
//           </div>

//           {/* Filter */}
//           <select
//             value={filterUser}
//             onChange={(e) => setFilterUser(e.target.value)}
//             className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//           >
//             <option value="all">All Users</option>
//             <option value="Hospital">Hospital</option>
//             <option value="Doctor">Doctor</option>
//             <option value="PolicyWriter">Policy Writer</option>
//             <option value="SuperAdmin">Admin</option>
//             <option value="Patient">Patient</option>
//           </select>
//         </div>
//       </div>

//       {/* Chat Messages */}
//       <div 
//         ref={chatContainerRef}
//         className="flex-1 overflow-y-auto p-4 space-y-4 bg-gray-50"
//         style={{ maxHeight: "400px" }}
//       >
//         {filteredMessages.length > 0 ? (
//           filteredMessages.map((message, index) => {
//             const isOwnMessage = message.sender === currentUser?.uid;
//             const showAvatar = index === 0 || filteredMessages[index - 1].sender !== message.sender;
            
//             return (
//               <div
//                 key={message.id || `msg_${index}`}
//                 className={`flex items-start space-x-3 ${
//                   isOwnMessage ? 'flex-row-reverse space-x-reverse' : ''
//                 }`}
//               >
//                 {/* Avatar */}
//                 {showAvatar && (
//                   <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-medium shadow-md ${getUserRoleColor(message.senderRole)}`}>
//                     {message.senderName?.charAt(0)?.toUpperCase() || '?'}
//                   </div>
//                 )}
                
//                 {/* Message Content */}
//                 <div className={`flex-1 max-w-xs sm:max-w-md lg:max-w-lg ${showAvatar ? '' : 'ml-13'} ${isOwnMessage && showAvatar ? 'mr-13' : ''}`}>
//                   {/* Message Header */}
//                   {showAvatar && (
//                     <div className={`flex items-center space-x-2 mb-2 ${isOwnMessage ? 'justify-end' : ''}`}>
//                       <span className="text-sm font-medium text-gray-900">
//                         {message.senderName}
//                       </span>
//                       <span className={`px-2 py-1 text-xs font-medium rounded-full border ${getUserRoleBadge(message.senderRole)}`}>
//                         {message.senderRole}
//                       </span>
//                       <span className="text-xs text-gray-500">
//                         {formatTime(message.timestamp)}
//                       </span>
//                     </div>
//                   )}

//                   {/* Message Bubble */}
//                   <div
//                     className={`rounded-lg p-4 shadow-sm ${
//                       isOwnMessage
//                         ? 'bg-teal-600 text-white'
//                         : 'bg-white text-gray-900 border border-gray-200'
//                     }`}
//                   >
//                     {/* Reply indicator */}
//                     {message.replyTo && (
//                       <div className={`text-xs mb-2 p-2 rounded ${
//                         isOwnMessage ? 'bg-teal-700 bg-opacity-50' : 'bg-gray-100'
//                       }`}>
//                         <Reply className="h-3 w-3 inline mr-1" />
//                         <span className="opacity-75">Replying to a message</span>
//                       </div>
//                     )}

//                     {/* Message text */}
//                     <p className="text-sm whitespace-pre-wrap break-words">
//                       {message.message}
//                     </p>

//                     {/* File attachments */}
//                     {message.attachments && message.attachments.length > 0 && (
//                       <div className="mt-3 space-y-2">
//                         <p className="text-xs opacity-75 font-medium">Attachments:</p>
//                         {message.attachments.map((attachment, idx) => (
//                           <div
//                             key={idx}
//                             className={`flex items-center space-x-2 p-2 rounded-lg border ${
//                               isOwnMessage ? 'bg-teal-700 bg-opacity-50 border-teal-500' : 'bg-gray-50 border-gray-200'
//                             }`}
//                           >
//                             <File className="h-4 w-4 flex-shrink-0" />
//                             <span className="text-xs flex-1 truncate">
//                               {attachment.fileName}
//                             </span>
//                             <button
//                               onClick={() => openDocument(attachment)}
//                               className={`text-xs hover:underline flex items-center space-x-1 ${
//                                 isOwnMessage ? 'text-teal-100' : 'text-teal-600'
//                               }`}
//                             >
//                               <Eye className="h-3 w-3" />
//                               <span>View</span>
//                             </button>
//                           </div>
//                         ))}
//                       </div>
//                     )}

//                     {/* Q&A Form */}
//                     {message.qnaQuestions && message.qnaQuestions.length > 0 && (
//                       <div className="mt-4 bg-white rounded-lg p-4 text-gray-900 border border-gray-200">
//                         <div className="flex items-center space-x-2 mb-4">
//                           <HelpCircle className="h-5 w-5 text-purple-600" />
//                           <h4 className="font-semibold text-purple-900">
//                             Q&A Form ({message.qnaQuestions.length} question{message.qnaQuestions.length > 1 ? 's' : ''})
//                           </h4>
//                         </div>
                        
//                         <div className="space-y-4">
//                           {message.qnaQuestions.map((question, qIdx) => (
//                             <div key={question.id || qIdx} className="border border-gray-200 rounded-lg p-4 bg-gray-50">
//                               <div className="mb-3">
//                                 <div className="flex items-start justify-between mb-2">
//                                   <p className="font-medium text-gray-900 text-sm">
//                                     <span className="text-purple-600 font-semibold">{qIdx + 1}.</span> {question.question}
//                                     {question.required && (
//                                       <span className="text-red-600 ml-1">*</span>
//                                     )}
//                                   </p>
//                                 </div>
//                                 {question.description && (
//                                   <p className="text-sm text-gray-600 mb-2">
//                                     {question.description}
//                                   </p>
//                                 )}
//                                 <div className="flex items-center space-x-2">
//                                   {question.required && (
//                                     <span className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded-full">
//                                       Required
//                                     </span>
//                                   )}
//                                   <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded-full">
//                                     {question.answerType === 'text' ? 'Text Answer' : 
//                                      question.answerType === 'file' ? 'File Upload' : 'Text + File'}
//                                   </span>
//                                 </div>
//                               </div>

//                               {/* Answer Section - Show for all users except the sender */}
//                               {message.sender !== currentUser?.uid && (
//                                 <div className="mt-4">
//                                   {answeringQuestion === `${message.id}_${question.id}` ? (
//                                     // Answer Form
//                                     <div className="space-y-4 bg-white rounded-lg p-4 border border-blue-200">
//                                       <div className="flex items-center space-x-2 mb-3">
//                                         <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
//                                         <span className="text-sm font-medium text-blue-700">Your Answer</span>
//                                       </div>

//                                       {/* Text Answer */}
//                                       {(question.answerType === "text" || question.answerType === "both") && (
//                                         <div>
//                                           <label className="block text-sm font-medium text-gray-700 mb-2">
//                                             Answer Text:
//                                           </label>
//                                           <textarea
//                                             value={questionAnswers[question.id]?.text || ""}
//                                             onChange={(e) => handleAnswerChange(question.id, e.target.value)}
//                                             rows="4"
//                                             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                             placeholder="Type your answer here..."
//                                           />
//                                         </div>
//                                       )}

//                                       {/* File Answer */}
//                                       {(question.answerType === "file" || question.answerType === "both") && (
//                                         <div>
//                                           <label className="block text-sm font-medium text-gray-700 mb-2">
//                                             Upload Files:
//                                           </label>
//                                           <div className="space-y-3">
//                                             <input
//                                               type="file"
//                                               multiple
//                                               className="hidden"
//                                               id={`answer-file-${question.id}`}
//                                               onChange={(e) => handleAnswerFileSelect(question.id, e)}
//                                             />
//                                             <button
//                                               onClick={() => document.getElementById(`answer-file-${question.id}`).click()}
//                                               className="flex items-center space-x-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
//                                             >
//                                               <Upload className="h-4 w-4" />
//                                               <span>Select Files</span>
//                                             </button>

//                                             {/* Show selected files */}
//                                             {questionAnswers[question.id]?.files?.length > 0 && (
//                                               <div className="space-y-2">
//                                                 <p className="text-sm font-medium text-gray-700">Selected Files:</p>
//                                                 {questionAnswers[question.id].files.map((file, fileIndex) => (
//                                                   <div key={fileIndex} className="flex items-center justify-between bg-gray-50 rounded-lg p-3 border">
//                                                     <div className="flex items-center space-x-2">
//                                                       <File className="h-4 w-4 text-gray-500" />
//                                                       <div>
//                                                         <span className="text-sm text-gray-700 font-medium">{file.name}</span>
//                                                         <span className="text-xs text-gray-500 block">
//                                                           {(file.size / 1024).toFixed(1)} KB
//                                                         </span>
//                                                       </div>
//                                                     </div>
//                                                     <button
//                                                       onClick={() => removeAnswerFile(question.id, fileIndex)}
//                                                       className="text-red-500 hover:text-red-700 p-1"
//                                                     >
//                                                       <X className="h-4 w-4" />
//                                                     </button>
//                                                   </div>
//                                                 ))}
//                                               </div>
//                                             )}
//                                           </div>
//                                         </div>
//                                       )}

//                                       {/* Submit/Cancel Buttons */}
//                                       <div className="flex items-center justify-between pt-4 border-t border-gray-200">
//                                         <button
//                                           onClick={() => setAnsweringQuestion(null)}
//                                           className="px-4 py-2 border border-gray-300 text-gray-600 rounded-lg hover:bg-gray-50 transition-colors"
//                                         >
//                                           Cancel
//                                         </button>
//                                         <button
//                                           onClick={() => handleSubmitAnswer(question.id, message.id)}
//                                           disabled={
//                                             actionLoading[`answer_${question.id}`] ||
//                                             (question.required && 
//                                               !questionAnswers[question.id]?.text?.trim() && 
//                                               !questionAnswers[question.id]?.files?.length)
//                                           }
//                                           className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2 transition-colors"
//                                         >
//                                           {actionLoading[`answer_${question.id}`] ? (
//                                             <>
//                                               <Loader className="h-4 w-4 animate-spin" />
//                                               <span>Submitting...</span>
//                                             </>
//                                           ) : (
//                                             <>
//                                               <CheckCircle className="h-4 w-4" />
//                                               <span>Submit Answer</span>
//                                             </>
//                                           )}
//                                         </button>
//                                       </div>
//                                     </div>
//                                   ) : (
//                                     // Answer Button or Existing Answers
//                                     <div className="space-y-3">
//                                       {/* Check if current user has answered */}
//                                       {(() => {
//                                         // Find user's answer more reliably
//                                         const userAnswer = question.answers?.find(
//                                           answer => answer.respondentId === currentUser?.uid
//                                         );
                                        
//                                         console.log('Checking user answer for question:', question.id, 'current user:', currentUser?.uid, 'found answer:', !!userAnswer);
//                                         console.log('All answers for this question:', question.answers?.map(a => ({ id: a.respondentId, name: a.respondentName })));
                                        
//                                         if (userAnswer) {
//                                           return (
//                                             <div className="bg-green-50 border border-green-200 rounded-lg p-3">
//                                               <div className="flex items-center space-x-2 mb-2">
//                                                 <CheckCircle className="h-4 w-4 text-green-600" />
//                                                 <span className="text-sm font-medium text-green-800">
//                                                   Your Answer Submitted
//                                                 </span>
//                                                 <span className="text-xs text-green-600">
//                                                   {formatDate(userAnswer.timestamp || userAnswer.createdAt)}
//                                                 </span>
//                                               </div>
//                                               {userAnswer.answerText && (
//                                                 <p className="text-sm text-green-700 mb-2 bg-green-100 p-2 rounded">
//                                                   {userAnswer.answerText}
//                                                 </p>
//                                               )}
//                                               {userAnswer.attachments?.length > 0 && (
//                                                 <div className="space-y-1">
//                                                   <p className="text-xs text-green-700 font-medium">Your Attachments:</p>
//                                                   {userAnswer.attachments.map((attachment, idx) => (
//                                                     <div key={idx} className="flex items-center space-x-2 text-green-700">
//                                                       <Paperclip className="h-3 w-3" />
//                                                       <span className="text-xs flex-1">{attachment.fileName}</span>
//                                                       <button
//                                                         onClick={() => openDocument(attachment)}
//                                                         className="text-green-600 hover:text-green-800 text-xs underline"
//                                                       >
//                                                         View
//                                                       </button>
//                                                     </div>
//                                                   ))}
//                                                 </div>
//                                               )}
                                              
//                                               {/* Allow re-answering */}
//                                               <button
//                                                 onClick={() => setAnsweringQuestion(`${message.id}_${question.id}`)}
//                                                 className="mt-2 text-xs text-green-600 hover:text-green-800 underline"
//                                               >
//                                                 Edit Answer
//                                               </button>
//                                             </div>
//                                           );
//                                         } else {
//                                           return (
//                                             <button
//                                               onClick={() => setAnsweringQuestion(`${message.id}_${question.id}`)}
//                                               className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
//                                             >
//                                               <HelpCircle className="h-4 w-4" />
//                                               <span>Answer Question</span>
//                                             </button>
//                                           );
//                                         }
//                                       })()}
                                      
//                                       {/* Show all answers from all users */}
//                                       {question.answers && question.answers.length > 0 && (
//                                         <div className="mt-4">
//                                           <div className="flex items-center justify-between mb-3">
//                                             <h6 className="text-sm font-medium text-gray-700">
//                                               All Responses ({question.answers.length})
//                                             </h6>
//                                             <button
//                                               onClick={() => toggleAnswerExpansion(question.id)}
//                                               className="flex items-center space-x-1 text-xs text-gray-500 hover:text-gray-700"
//                                             >
//                                               <span>{expandedAnswers[question.id] ? 'Hide' : 'Show'}</span>
//                                               {expandedAnswers[question.id] ? 
//                                                 <ChevronUp className="h-3 w-3" /> : 
//                                                 <ChevronDown className="h-3 w-3" />
//                                               }
//                                             </button>
//                                           </div>
                                          
//                                           {(expandedAnswers[question.id] || question.answers.length <= 3) && (
//                                             <div className="space-y-3 max-h-60 overflow-y-auto">
//                                               {question.answers
//                                                 .sort((a, b) => {
//                                                   // Sort answers by timestamp
//                                                   const timeA = a.timestamp?.toDate ? a.timestamp.toDate() : new Date(a.createdAt || 0);
//                                                   const timeB = b.timestamp?.toDate ? b.timestamp.toDate() : new Date(b.createdAt || 0);
//                                                   return timeB - timeA; // Latest first
//                                                 })
//                                                 .map((answer, answerIdx) => (
//                                                 <div key={answer.id || answerIdx} className="bg-white border border-gray-200 rounded-lg p-3 shadow-sm">
//                                                   <div className="flex items-center space-x-2 mb-2">
//                                                     <div className={`w-6 h-6 rounded-full flex items-center justify-center text-white text-xs font-medium ${getUserRoleColor(answer.respondentRole)}`}>
//                                                       {answer.respondentName?.charAt(0)?.toUpperCase()}
//                                                     </div>
//                                                     <span className="text-sm font-medium text-gray-700">
//                                                       {answer.respondentName}
//                                                     </span>
//                                                     <span className={`px-2 py-1 text-xs rounded-full border ${getUserRoleBadge(answer.respondentRole)}`}>
//                                                       {answer.respondentRole}
//                                                     </span>
//                                                     <span className="text-xs text-gray-500">
//                                                       {formatDate(answer.timestamp || answer.createdAt)}
//                                                     </span>
//                                                     {answer.respondentId === currentUser?.uid && (
//                                                       <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full">
//                                                         Your Answer
//                                                       </span>
//                                                     )}
//                                                   </div>
//                                                   {answer.answerText && (
//                                                     <div className="mb-2">
//                                                       <p className="text-sm text-gray-700 bg-gray-50 p-3 rounded-lg border">
//                                                         {answer.answerText}
//                                                       </p>
//                                                     </div>
//                                                   )}
//                                                   {answer.attachments?.length > 0 && (
//                                                     <div className="space-y-2">
//                                                       <p className="text-xs text-gray-600 font-medium">Attachments:</p>
//                                                       <div className="grid grid-cols-1 gap-2">
//                                                         {answer.attachments.map((attachment, attIdx) => (
//                                                           <div key={attIdx} className="flex items-center justify-between bg-gray-50 rounded-lg p-2 border">
//                                                             <div className="flex items-center space-x-2">
//                                                               <Paperclip className="h-4 w-4 text-gray-400" />
//                                                               <span className="text-xs text-gray-600 font-medium">
//                                                                 {attachment.fileName}
//                                                               </span>
//                                                               <span className="text-xs text-gray-400">
//                                                                 ({(attachment.size / 1024).toFixed(1)} KB)
//                                                               </span>
//                                                             </div>
//                                                             <button
//                                                               onClick={() => openDocument(attachment)}
//                                                               className="text-blue-500 hover:text-blue-700 text-xs underline flex items-center space-x-1"
//                                                             >
//                                                               <Eye className="h-3 w-3" />
//                                                               <span>View</span>
//                                                             </button>
//                                                           </div>
//                                                         ))}
//                                                       </div>
//                                                     </div>
//                                                   )}
//                                                 </div>
//                                               ))}
                                              
//                                               {/* Show expansion button if more than 3 answers and not expanded */}
//                                               {question.answers.length > 3 && !expandedAnswers[question.id] && (
//                                                 <button
//                                                   onClick={() => toggleAnswerExpansion(question.id)}
//                                                   className="w-full py-2 text-xs text-gray-500 hover:text-gray-700 border border-gray-200 rounded-lg hover:bg-gray-50"
//                                                 >
//                                                   Show {question.answers.length - 3} more answers
//                                                 </button>
//                                               )}
//                                             </div>
//                                           )}
//                                         </div>
//                                       )}
//                                     </div>
//                                   )}
//                                 </div>
//                               )}
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     )}
//                   </div>

//                   {/* Message actions */}
//                   <div className={`flex items-center space-x-3 mt-2 ${isOwnMessage ? 'justify-end' : ''}`}>
//                     <button
//                       onClick={() => setReplyingTo(message)}
//                       className="text-xs text-gray-500 hover:text-gray-700 flex items-center space-x-1 transition-colors"
//                     >
//                       <Reply className="h-3 w-3" />
//                       <span>Reply</span>
//                     </button>
//                     <span className="text-xs text-gray-400">
//                       {formatDate(message.timestamp)}
//                     </span>
//                     {!message.readBy?.includes(currentUser?.uid) && message.sender !== currentUser?.uid && (
//                       <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             );
//           })
//         ) : (
//           <div className="text-center py-12">
//             <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
//               <MessageSquare className="h-8 w-8 text-gray-400" />
//             </div>
//             <h3 className="text-lg font-medium text-gray-900 mb-2">
//               {searchTerm || filterUser !== "all" ? "No messages found" : "No messages yet"}
//             </h3>
//             <p className="text-gray-600 max-w-sm mx-auto">
//               {searchTerm || filterUser !== "all"
//                 ? "Try adjusting your search or filter criteria"
//                 : "Start the conversation by sending a message below"}
//             </p>
//           </div>
//         )}
//         <div ref={messagesEndRef} />
//       </div>

//       {/* Message Input Area */}
//       <div className="border-t border-gray-200 bg-white p-4">
//         {/* Reply indicator */}
//         {replyingTo && (
//           <div className="bg-blue-50 rounded-lg p-3 mb-4 border-l-4 border-blue-500">
//             <div className="flex items-center justify-between">
//               <div className="flex-1">
//                 <div className="flex items-center space-x-2 mb-1">
//                   <Reply className="h-4 w-4 text-blue-600" />
//                   <span className="text-sm font-medium text-blue-700">
//                     Replying to {replyingTo.senderName}
//                   </span>
//                   <span className={`px-2 py-1 text-xs rounded-full ${getUserRoleBadge(replyingTo.senderRole)}`}>
//                     {replyingTo.senderRole}
//                   </span>
//                 </div>
//                 <p className="text-sm text-blue-600 truncate">
//                   {replyingTo.message.length > 100 ? 
//                     `${replyingTo.message.substring(0, 100)}...` : 
//                     replyingTo.message
//                   }
//                 </p>
//               </div>
//               <button
//                 onClick={() => setReplyingTo(null)}
//                 className="text-blue-400 hover:text-blue-600 p-1"
//               >
//                 <X className="h-4 w-4" />
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Message Type Selector */}
//         <div className="flex items-center space-x-3 mb-4">
//           <span className="text-sm font-medium text-gray-700">Message type:</span>
//           <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg">
//             <button
//               onClick={() => {
//                 setMessageType("text");
//                 setShowQnAForm(false);
//               }}
//               className={`px-3 py-2 rounded-md text-sm font-medium transition-all ${
//                 messageType === "text"
//                   ? "bg-white text-teal-600 shadow-sm"
//                   : "text-gray-600 hover:text-gray-900"
//               }`}
//             >
//               <Type className="h-4 w-4 inline mr-1" />
//               Text
//             </button>
//             <button
//               onClick={() => {
//                 setMessageType("file");
//                 setShowQnAForm(false);
//               }}
//               className={`px-3 py-2 rounded-md text-sm font-medium transition-all ${
//                 messageType === "file"
//                   ? "bg-white text-teal-600 shadow-sm"
//                   : "text-gray-600 hover:text-gray-900"
//               }`}
//             >
//               <File className="h-4 w-4 inline mr-1" />
//               File
//             </button>
//             <button
//               onClick={() => {
//                 setMessageType("qna");
//                 setShowQnAForm(true);
//               }}
//               className={`px-3 py-2 rounded-md text-sm font-medium transition-all ${
//                 messageType === "qna"
//                   ? "bg-white text-teal-600 shadow-sm"
//                   : "text-gray-600 hover:text-gray-900"
//               }`}
//             >
//               <HelpCircle className="h-4 w-4 inline mr-1" />
//               Q&A Form
//             </button>
//           </div>
//         </div>

//         {/* Text/File Message Input */}
//         {(messageType === "text" || messageType === "file") && (
//           <div className="space-y-3">
//             <div className="flex space-x-3">
//               <div className="flex-1 relative" ref={autocompleteRef}>
//                 <textarea
//                   value={newMessage}
//                   onChange={handleMessageChange}
//                   placeholder={
//                     messageType === "file"
//                       ? "Add description for files (optional)..."
//                       : "Type your message or search standard queries..."
//                   }
//                   rows="3"
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 resize-none"
//                   onKeyPress={(e) => {
//                     if (e.key === 'Enter' && !e.shiftKey && !showAutocomplete) {
//                       e.preventDefault();
//                       handleSendMessage();
//                     }
//                   }}
//                 />
                
//                 {/* Standard Queries Autocomplete Dropdown */}
//                 {showAutocomplete && (
//                   <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
//                     {autocompleteLoading ? (
//                       <div className="p-3 text-center text-gray-500">
//                         <Loader className="h-4 w-4 animate-spin mx-auto mb-1" />
//                         Searching standard queries...
//                       </div>
//                     ) : filteredQueries.length > 0 ? (
//                       <>
//                         <div className="px-3 py-2 text-xs text-gray-500 bg-gray-50 border-b">
//                           Standard Queries ({filteredQueries.length})
//                         </div>
//                         {filteredQueries.map((query) => (
//                           <button
//                             key={query.id}
//                             onClick={() => selectStandardQuery(query)}
//                             className="w-full text-left p-3 hover:bg-gray-50 border-b border-gray-100 last:border-b-0 transition-colors"
//                           >
//                             <div className="font-medium text-gray-900 text-sm mb-1">
//                               {query.queryHeader}
//                             </div>
//                             <div className="text-gray-600 text-xs mb-1">
//                               {query.queryDescription}
//                             </div>
//                             <div className="flex flex-wrap gap-1">
//                               <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
//                                 {query.queryType}
//                               </span>
//                               {query.requirementStages?.map((stage, index) => (
//                                 <span
//                                   key={index}
//                                   className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800"
//                                 >
//                                   {stage}
//                                 </span>
//                               ))}
//                             </div>
//                           </button>
//                         ))}
//                       </>
//                     ) : (
//                       <div className="p-3 text-center text-gray-500 text-sm">
//                         No matching standard queries found
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>
//               <div className="flex flex-col space-y-2">
//                 {messageType === "file" && (
//                   <button
//                     onClick={() => fileInputRef.current?.click()}
//                     className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 flex items-center space-x-2 transition-colors"
//                   >
//                     <Upload className="h-4 w-4" />
//                     <span>Files</span>
//                   </button>
//                 )}
//                 <button
//                   onClick={handleSendMessage}
//                   disabled={
//                     actionLoading.sendMessage ||
//                     (messageType === "text" && !newMessage.trim()) ||
//                     (messageType === "file" && selectedFiles.length === 0)
//                   }
//                   className="px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2 transition-colors"
//                 >
//                   {actionLoading.sendMessage ? (
//                     <Loader className="h-4 w-4 animate-spin" />
//                   ) : (
//                     <Send className="h-4 w-4" />
//                   )}
//                   <span>Send</span>
//                 </button>
//               </div>
//             </div>

//             {/* File Upload Area */}
//             {messageType === "file" && (
//               <>
//                 <input
//                   ref={fileInputRef}
//                   type="file"
//                   multiple
//                   className="hidden"
//                   onChange={handleFileSelect}
//                 />
                
//                 {/* Selected Files Display */}
//                 {selectedFiles.length > 0 && (
//                   <div className="bg-gray-50 rounded-lg border border-gray-200 p-4">
//                     <div className="flex items-center justify-between mb-3">
//                       <span className="text-sm font-medium text-gray-700">
//                         Selected Files ({selectedFiles.length})
//                       </span>
//                       {actionLoading.uploadingFiles && (
//                         <div className="flex items-center space-x-2 text-blue-600">
//                           <Loader className="h-3 w-3 animate-spin" />
//                           <span className="text-xs">Uploading...</span>
//                         </div>
//                       )}
//                     </div>
//                     <div className="space-y-2">
//                       {selectedFiles.map((file, index) => (
//                         <div
//                           key={index}
//                           className="flex items-center justify-between bg-white rounded-lg p-3 border border-gray-200"
//                         >
//                           <div className="flex items-center space-x-3">
//                             <File className="h-5 w-5 text-gray-500" />
//                             <div>
//                               <span className="text-sm text-gray-900 font-medium block">
//                                 {file.name}
//                               </span>
//                               <span className="text-xs text-gray-500">
//                                 {(file.size / 1024).toFixed(1)} KB
//                               </span>
//                             </div>
//                           </div>
//                           <button
//                             onClick={() => removeSelectedFile(index)}
//                             className="text-red-500 hover:text-red-700 p-1"
//                           >
//                             <X className="h-4 w-4" />
//                           </button>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
//         )}

//         {/* Q&A Form Builder */}
//         {messageType === "qna" && showQnAForm && (
//           <div className="bg-gray-50 rounded-lg border border-gray-200 p-6">
//             <div className="flex items-center justify-between mb-6">
//               <div className="flex items-center space-x-2">
//                 <HelpCircle className="h-5 w-5 text-purple-600" />
//                 <h4 className="text-lg font-semibold text-gray-900">Create Q&A Form</h4>
//               </div>
//               <button
//                 onClick={() => {
//                   setShowQnAForm(false);
//                   setQnaQuestions([]);
//                   setMessageType("text");
//                 }}
//                 className="text-gray-400 hover:text-gray-600 p-1"
//               >
//                 <X className="h-5 w-5" />
//               </button>
//             </div>

//             {/* Existing Questions */}
//             {qnaQuestions.length > 0 && (
//               <div className="mb-6">
//                 <h5 className="text-sm font-medium text-gray-700 mb-3">
//                   Questions ({qnaQuestions.length})
//                 </h5>
//                 <div className="space-y-3">
//                   {qnaQuestions.map((q, index) => (
//                     <div key={q.id} className="bg-white rounded-lg p-4 border border-gray-200">
//                       <div className="flex items-start justify-between">
//                         <div className="flex-1">
//                           <div className="flex items-center space-x-2 mb-2">
//                             <span className="text-sm font-semibold text-purple-600">
//                               Q{index + 1}:
//                             </span>
//                             {q.required && (
//                               <span className="px-2 py-1 bg-red-100 text-red-800 text-xs rounded-full">
//                                 Required
//                               </span>
//                             )}
//                             <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">
//                               {q.answerType === 'text' ? 'Text' : 
//                                q.answerType === 'file' ? 'File' : 'Text + File'}
//                             </span>
//                           </div>
//                           <p className="text-gray-900 font-medium text-sm mb-1">
//                             {q.question}
//                           </p>
//                           {q.description && (
//                             <p className="text-sm text-gray-600">
//                               {q.description}
//                             </p>
//                           )}
//                         </div>
//                         <button
//                           onClick={() => removeQuestion(q.id)}
//                           className="text-red-600 hover:text-red-800 p-1 ml-3"
//                         >
//                           <Trash2 className="h-4 w-4" />
//                         </button>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             )}

//             {/* Add New Question */}
//             <div className="border-t border-gray-200 pt-6">
//               <h5 className="text-sm font-medium text-gray-700 mb-4">
//                 Add New Question
//               </h5>
//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Question *
//                   </label>
//                   <textarea
//                     value={newQuestion.question}
//                     onChange={(e) =>
//                       setNewQuestion((prev) => ({
//                         ...prev,
//                         question: e.target.value,
//                       }))
//                     }
//                     rows="3"
//                     className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
//                     placeholder="Enter your question..."
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Description (Optional)
//                   </label>
//                   <input
//                     type="text"
//                     value={newQuestion.description}
//                     onChange={(e) =>
//                       setNewQuestion((prev) => ({
//                         ...prev,
//                         description: e.target.value,
//                       }))
//                     }
//                     className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
//                     placeholder="Add additional context or instructions..."
//                   />
//                 </div>

//                 <div className="flex items-center justify-between">
//                   <div className="flex items-center space-x-4">
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-1">
//                         Answer Type
//                       </label>
//                       <select
//                         value={newQuestion.answerType}
//                         onChange={(e) =>
//                           setNewQuestion((prev) => ({
//                             ...prev,
//                             answerType: e.target.value,
//                           }))
//                         }
//                         className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
//                       >
//                         <option value="text">Text Answer</option>
//                         <option value="file">File Upload</option>
//                         <option value="both">Text + File</option>
//                       </select>
//                     </div>

//                     <div className="pt-6">
//                       <label className="flex items-center space-x-2">
//                         <input
//                           type="checkbox"
//                           checked={newQuestion.required}
//                           onChange={(e) =>
//                             setNewQuestion((prev) => ({
//                               ...prev,
//                               required: e.target.checked,
//                             }))
//                           }
//                           className="rounded border-gray-300 text-purple-600 focus:ring-purple-500"
//                         />
//                         <span className="text-sm text-gray-700">Required</span>
//                       </label>
//                     </div>
//                   </div>

//                   <button
//                     onClick={handleAddQuestion}
//                     disabled={!newQuestion.question.trim()}
//                     className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2 transition-colors"
//                   >
//                     <Plus className="h-4 w-4" />
//                     <span>Add Question</span>
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Send Q&A Form */}
//             {qnaQuestions.length > 0 && (
//               <div className="border-t border-gray-200 pt-6 mt-6">
//                 <button
//                   onClick={handleSendMessage}
//                   disabled={actionLoading.sendMessage}
//                   className="w-full px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2 transition-colors"
//                 >
//                   {actionLoading.sendMessage ? (
//                     <>
//                       <Loader className="h-5 w-5 animate-spin" />
//                       <span>Sending Q&A Form...</span>
//                     </>
//                   ) : (
//                     <>
//                       <HelpCircle className="h-5 w-5" />
//                       <span>Send Q&A Form ({qnaQuestions.length} question{qnaQuestions.length > 1 ? 's' : ''})</span>
//                     </>
//                   )}
//                 </button>
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default DiscussionComponent;


// Import your discussion service


import StandardQueriesSelector from "../common/StandardQueriesSelector";

// Mock auth context - replace with your actual auth context


const DiscussionComponent = ({ 
  applicationId = "app123",
  onDiscussionUpdate,
  disableQna = false
}) => {
  const { userData } = useAuth();
  const currentUser = {...userData, uid: auth?.currentUser?.uid} || null;
  const messagesEndRef = useRef(null);
  const fileInputRef = useRef(null);

  // Core state
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [unreadCount, setUnreadCount] = useState(0);

  // Message input state
  const [newMessage, setNewMessage] = useState("");
  const [messageType, setMessageType] = useState("text");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [replyingTo, setReplyingTo] = useState(null);

  // UI state
  const [searchTerm, setSearchTerm] = useState("");
  const [filterUser, setFilterUser] = useState("all");
  const [actionLoading, setActionLoading] = useState({});
  const [expandedAnswers, setExpandedAnswers] = useState({});

  // Q&A state
  const [showQnAForm, setShowQnAForm] = useState(false);
  const [qnaQuestions, setQnaQuestions] = useState([]);
  const [newQuestion, setNewQuestion] = useState({
    question: "",
    required: false,
    answerType: "text",
    description: "",
  });
  const [answeringQuestion, setAnsweringQuestion] = useState(null);
  const [questionAnswers, setQuestionAnswers] = useState({});

  // Standard queries selector state
  const [showStandardQueriesSelector, setShowStandardQueriesSelector] = useState(false);

  // Initialize component
  useEffect(() => {
    console.log('Initializing discussion for application:', applicationId);
    loadMessages();

    // Set up real-time listener
    const unsubscribe = subscribeToApplicationUpdates(applicationId, handleRealtimeUpdate);

    // Mark messages as read
    setTimeout(markAllMessagesAsRead, 1000);

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [applicationId, currentUser?.uid]);

  // Auto-scroll to bottom when messages change
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Notify parent of unread count changes
  useEffect(() => {
    if (onDiscussionUpdate) {
      onDiscussionUpdate(unreadCount);
    }
  }, [unreadCount, onDiscussionUpdate]);

  // Load messages from Firestore
  const loadMessages = async () => {
    setLoading(true);
    try {
      const result = await getApplicationDiscussions(applicationId);
      if (result.success) {
        const sortedMessages = result.discussions.sort((a, b) => {
          const timeA = getTimestamp(a.timestamp);
          const timeB = getTimestamp(b.timestamp);
          return timeA - timeB;
        });
        setMessages(sortedMessages);
        calculateUnreadMessages(sortedMessages);
      }
    } catch (error) {
      console.error("Error loading messages:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle real-time updates
  const handleRealtimeUpdate = (updatedData) => {
    if (updatedData.error) {
      console.error('Real-time error:', updatedData.error);
      return;
    }
    
    if (updatedData.discussionMessages) {
      console.log('Real-time update received:', updatedData.discussionMessages.length, 'messages');
      setMessages(updatedData.discussionMessages);
      calculateUnreadMessages(updatedData.discussionMessages);
    }
  };

  // Calculate unread messages
  const calculateUnreadMessages = (messageList) => {
    if (!messageList || !currentUser?.uid) return;
    const unread = messageList.filter(msg => 
      !msg.readBy?.includes(currentUser.uid) && msg.sender !== currentUser.uid
    ).length;
    setUnreadCount(unread);
  };

  // Mark all messages as read
  const markAllMessagesAsRead = async () => {
    if (!currentUser?.uid) return;
    try {
      await markMessagesAsRead(applicationId, currentUser.uid);
      setUnreadCount(0);
    } catch (error) {
      console.error("Error marking messages as read:", error);
    }
  };

  // Utility functions
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const getTimestamp = (timestamp) => {
    if (timestamp?.toDate) return timestamp.toDate();
    if (timestamp instanceof Date) return timestamp;
    if (typeof timestamp === 'string') return new Date(timestamp);
    return new Date();
  };

  const formatDate = (timestamp) => {
    const date = getTimestamp(timestamp);
    return date.toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const formatTime = (timestamp) => {
    const date = getTimestamp(timestamp);
    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getUserRoleColor = (role) => {
    const colors = {
      Hospital: "bg-blue-500",
      Doctor: "bg-green-500",
      PolicyWriter: "bg-purple-500",
      SuperAdmin: "bg-red-500",
      Patient: "bg-orange-500",
    };
    return colors[role] || "bg-gray-500";
  };

  const getUserRoleBadge = (role) => {
    const colors = {
      Hospital: "bg-blue-100 text-blue-800 border-blue-200",
      Doctor: "bg-green-100 text-green-800 border-green-200",
      PolicyWriter: "bg-purple-100 text-purple-800 border-purple-200",
      SuperAdmin: "bg-red-100 text-red-800 border-red-200",
      Patient: "bg-orange-100 text-orange-800 border-orange-200",
    };
    return colors[role] || "bg-gray-100 text-gray-800 border-gray-200";
  };

  // File handling
  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles(prev => [...prev, ...files]);
  };

  const removeSelectedFile = (index) => {
    setSelectedFiles(prev => prev.filter((_, i) => i !== index));
  };

  // Q&A Question management
  const handleAddQuestion = () => {
    if (!newQuestion.question.trim()) return;
    
    const questionWithId = {
      ...newQuestion,
      id: `q_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
    };
    
    setQnaQuestions(prev => [...prev, questionWithId]);
    setNewQuestion({
      question: "",
      required: false,
      answerType: "text",
      description: "",
    });
  };

  const removeQuestion = (questionId) => {
    setQnaQuestions(prev => prev.filter(q => q.id !== questionId));
  };

  // Handle standard query selection
  const handleSelectStandardQuery = (query) => {
    setNewMessage(query.queryDescription || query.documentDescription || '');
    setShowStandardQueriesSelector(false);
  };

  // Send message
  const handleSendMessage = async () => {
    if (messageType === "text" && !newMessage.trim()) return;
    if (messageType === "file" && selectedFiles.length === 0) return;
    if (messageType === "qna" && qnaQuestions.length === 0) return;

    setActionLoading(prev => ({ ...prev, sendMessage: true }));
    
    try {
      let messageData = {
        message: newMessage || "",
        sender: currentUser?.uid,
        senderName: currentUser.profile?.name || currentUser.email,
        senderRole: currentUser.role,
        messageType,
        readBy: [currentUser?.uid],
        replyTo: replyingTo?.id || null,
      };

      // Handle Q&A message
      if (messageType === "qna") {
        messageData.qnaQuestions = qnaQuestions.map(q => ({ ...q, answers: [] }));
        messageData.message = `📋 Q&A Form: ${qnaQuestions.length} question${qnaQuestions.length > 1 ? 's' : ''}`;
      }

      // Upload files
      if (selectedFiles.length > 0) {
        setActionLoading(prev => ({ ...prev, uploadingFiles: true }));
        const uploadPromises = selectedFiles.map(file =>
          uploadDiscussionDocument(applicationId, file, {
            uploadedBy: currentUser?.uid,
            uploaderName: currentUser.profile?.name || currentUser.email,
          })
        );
        const uploadResults = await Promise.all(uploadPromises);
        messageData.attachments = uploadResults
          .filter(result => result.success)
          .map(result => result.document);
        setActionLoading(prev => ({ ...prev, uploadingFiles: false }));
      }

      const result = await sendDiscussionMessage(applicationId, messageData);
      
      if (result.success) {
        // Reset form
        setNewMessage("");
        setSelectedFiles([]);
        setReplyingTo(null);
        setQnaQuestions([]);
        setShowQnAForm(false);
        setMessageType("text");
      } else {
        throw new Error(result.error);
      }
    } catch (error) {
      console.error("Error sending message:", error);
      alert("Failed to send message: " + error.message);
    } finally {
      setActionLoading(prev => ({ 
        ...prev, 
        sendMessage: false, 
        uploadingFiles: false 
      }));
    }
  };

  // Q&A Answer handling
  const handleAnswerChange = (questionId, text) => {
    setQuestionAnswers(prev => ({
      ...prev,
      [questionId]: {
        ...prev[questionId],
        text,
        files: prev[questionId]?.files || []
      }
    }));
  };

  const handleAnswerFileSelect = (questionId, event) => {
    const files = Array.from(event.target.files);
    setQuestionAnswers(prev => ({
      ...prev,
      [questionId]: {
        ...prev[questionId],
        text: prev[questionId]?.text || "",
        files: [...(prev[questionId]?.files || []), ...files]
      }
    }));
  };

  const removeAnswerFile = (questionId, fileIndex) => {
    setQuestionAnswers(prev => ({
      ...prev,
      [questionId]: {
        ...prev[questionId],
        files: prev[questionId]?.files?.filter((_, i) => i !== fileIndex) || []
      }
    }));
  };

  const handleSubmitAnswer = async (questionId, messageId) => {
    const answer = questionAnswers[questionId];
    if (!answer?.text?.trim() && !answer?.files?.length) return;

    setActionLoading(prev => ({ ...prev, [`answer_${questionId}`]: true }));
    
    try {
      let answerData = {
        questionId,
        messageId,
        answerText: answer.text || "",
        respondentId: currentUser?.uid,
        respondentName: currentUser.profile?.name || currentUser.email,
        respondentRole: currentUser.role,
      };

      // Upload answer files
      if (answer.files && answer.files.length > 0) {
        const uploadPromises = answer.files.map(file =>
          uploadDiscussionDocument(applicationId, file, {
            uploadedBy: currentUser?.uid,
            uploaderName: currentUser.profile?.name || currentUser.email,
            questionId,
          })
        );
        const uploadResults = await Promise.all(uploadPromises);
        answerData.attachments = uploadResults
          .filter(result => result.success)
          .map(result => result.document);
      }

      const result = await submitQuestionAnswer(applicationId, answerData);
      
      if (result.success) {
        setQuestionAnswers(prev => ({
          ...prev,
          [questionId]: { text: "", files: [] }
        }));
        setAnsweringQuestion(null);
      } else {
        throw new Error(result.error);
      }
    } catch (error) {
      console.error("Error submitting answer:", error);
      alert("Failed to submit answer: " + error.message);
    } finally {
      setActionLoading(prev => ({ ...prev, [`answer_${questionId}`]: false }));
    }
  };

  // Filter messages
  const filterMessages = (messageList) => {
    return messageList.filter(message => {
      const matchesSearch = 
        message.message?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        message.senderName?.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesUser = filterUser === "all" || message.senderRole === filterUser;
      return matchesSearch && matchesUser;
    });
  };

  const openDocument = (document) => {
    window.open(document.url, "_blank");
  };

  const toggleAnswerExpansion = (questionId) => {
    setExpandedAnswers(prev => ({
      ...prev,
      [questionId]: !prev[questionId]
    }));
  };

  // Render Q&A Answer Section
  const renderQnAAnswerSection = (question, message) => {
    const isFormCreator = message.sender === currentUser?.uid;
    const userAnswer = question.answers?.find(ans => ans.respondentId === currentUser?.uid);
    const allAnswers = question.answers || [];

    if (isFormCreator) {
      // Form creator view - can only see answers
      return (
        <div className="mt-4 space-y-3">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
            <div className="flex items-center space-x-2">
              <CheckCircle className="h-4 w-4 text-blue-600" />
              <span className="text-sm font-medium text-blue-800">
                You created this form
              </span>
              <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded-full">
                {allAnswers.length} response{allAnswers.length !== 1 ? 's' : ''}
              </span>
            </div>
          </div>

          {allAnswers.length > 0 ? (
            <div className="space-y-3">
              <h6 className="text-sm font-medium text-gray-700">All Responses:</h6>
              {allAnswers
                .sort((a, b) => getTimestamp(b.timestamp || b.createdAt) - getTimestamp(a.timestamp || a.createdAt))
                .map((answer, idx) => (
                  <div key={answer.id || idx} className="bg-white border border-gray-200 rounded-lg p-3">
                    <div className="flex items-center space-x-2 mb-2">
                      <div className={`w-6 h-6 rounded-full flex items-center justify-center text-white text-xs font-medium ${getUserRoleColor(answer.respondentRole)}`}>
                        {answer.respondentName?.charAt(0)?.toUpperCase()}
                      </div>
                      <span className="text-sm font-medium text-gray-700">{answer.respondentName}</span>
                      <span className={`px-2 py-1 text-xs rounded-full border ${getUserRoleBadge(answer.respondentRole)}`}>
                        {answer.respondentRole}
                      </span>
                      <span className="text-xs text-gray-500">{formatDate(answer.timestamp || answer.createdAt)}</span>
                    </div>
                    {answer.answerText && (
                      <p className="text-sm text-gray-700 bg-gray-50 p-2 rounded mb-2">{answer.answerText}</p>
                    )}
                    {answer.attachments?.length > 0 && (
                      <div className="space-y-1">
                        <p className="text-xs text-gray-600 font-medium">Attachments:</p>
                        {answer.attachments.map((att, attIdx) => (
                          <div key={attIdx} className="flex items-center justify-between bg-gray-50 rounded p-2">
                            <div className="flex items-center space-x-2">
                              <Paperclip className="h-3 w-3 text-gray-400" />
                              <span className="text-xs text-gray-600">{att.fileName}</span>
                            </div>
                            <button
                              onClick={() => openDocument(att)}
                              className="text-blue-500 hover:text-blue-700 text-xs underline"
                            >
                              View
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
            </div>
          ) : (
            <div className="text-center py-4 text-gray-500">
              <HelpCircle className="h-8 w-8 mx-auto mb-2 text-gray-300" />
              <p className="text-sm">No responses yet</p>
            </div>
          )}
        </div>
      );
    } else {
      // Responder view - can answer and see answers
      return (
        <div className="mt-4 space-y-3">
          {answeringQuestion === `${message.id}_${question.id}` ? (
            // Answer form
            <div className="bg-white border border-blue-200 rounded-lg p-4">
              <h6 className="text-sm font-medium text-blue-700 mb-3">Your Answer</h6>
              
              {(question.answerType === "text" || question.answerType === "both") && (
                <div className="mb-3">
                  <textarea
                    value={questionAnswers[question.id]?.text || ""}
                    onChange={(e) => handleAnswerChange(question.id, e.target.value)}
                    rows="3"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Type your answer..."
                  />
                </div>
              )}

              {(question.answerType === "file" || question.answerType === "both") && (
                <div className="mb-3">
                  <input
                    type="file"
                    multiple
                    className="hidden"
                    id={`answer-file-${question.id}`}
                    onChange={(e) => handleAnswerFileSelect(question.id, e)}
                  />
                  <button
                    onClick={() => document.getElementById(`answer-file-${question.id}`).click()}
                    className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
                  >
                    <Upload className="h-4 w-4" />
                    <span>Select Files</span>
                  </button>
                  
                  {questionAnswers[question.id]?.files?.length > 0 && (
                    <div className="mt-2 space-y-1">
                      {questionAnswers[question.id].files.map((file, idx) => (
                        <div key={idx} className="flex items-center justify-between bg-gray-50 rounded p-2">
                          <span className="text-sm text-gray-700">{file.name}</span>
                          <button
                            onClick={() => removeAnswerFile(question.id, idx)}
                            className="text-red-500 hover:text-red-700"
                          >
                            <X className="h-4 w-4" />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              <div className="flex justify-between">
                <button
                  onClick={() => setAnsweringQuestion(null)}
                  className="px-3 py-2 border border-gray-300 text-gray-600 rounded-lg hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  onClick={() => handleSubmitAnswer(question.id, message.id)}
                  disabled={actionLoading[`answer_${question.id}`]}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 flex items-center space-x-2"
                >
                  {actionLoading[`answer_${question.id}`] ? (
                    <><Loader className="h-4 w-4 animate-spin" /> <span>Submitting...</span></>
                  ) : (
                    <><CheckCircle className="h-4 w-4" /> <span>Submit</span></>
                  )}
                </button>
              </div>
            </div>
          ) : (
            // Show answer button or existing answer
            <div className="space-y-3">
              {userAnswer ? (
                <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                  <div className="flex items-center space-x-2 mb-2">
                    <CheckCircle className="h-4 w-4 text-green-600" />
                    <span className="text-sm font-medium text-green-800">Your Answer Submitted</span>
                  </div>
                  {userAnswer.answerText && (
                    <p className="text-sm text-green-700 bg-green-100 p-2 rounded">{userAnswer.answerText}</p>
                  )}
                  <button
                    onClick={() => setAnsweringQuestion(`${message.id}_${question.id}`)}
                    className="mt-2 text-xs text-green-600 hover:text-green-800 underline"
                  >
                    Edit Answer
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => setAnsweringQuestion(`${message.id}_${question.id}`)}
                  className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                >
                  <HelpCircle className="h-4 w-4" />
                  <span>Answer Question</span>
                </button>
              )}

              {/* Show all answers */}
              {allAnswers.length > 0 && (
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <h6 className="text-sm font-medium text-gray-700">
                      All Responses ({allAnswers.length})
                    </h6>
                    <button
                      onClick={() => toggleAnswerExpansion(question.id)}
                      className="flex items-center space-x-1 text-xs text-gray-500 hover:text-gray-700"
                    >
                      <span>{expandedAnswers[question.id] ? 'Hide' : 'Show'}</span>
                      {expandedAnswers[question.id] ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />}
                    </button>
                  </div>

                  {expandedAnswers[question.id] && (
                    <div className="space-y-2 max-h-48 overflow-y-auto">
                      {allAnswers
                        .sort((a, b) => getTimestamp(b.timestamp || b.createdAt) - getTimestamp(a.timestamp || a.createdAt))
                        .map((answer, idx) => (
                          <div key={answer.id || idx} className="bg-white border border-gray-200 rounded p-2">
                            <div className="flex items-center space-x-2 mb-1">
                              <div className={`w-5 h-5 rounded-full flex items-center justify-center text-white text-xs ${getUserRoleColor(answer.respondentRole)}`}>
                                {answer.respondentName?.charAt(0)?.toUpperCase()}
                              </div>
                              <span className="text-sm font-medium text-gray-700">{answer.respondentName}</span>
                              <span className={`px-1 py-0.5 text-xs rounded ${getUserRoleBadge(answer.respondentRole)}`}>
                                {answer.respondentRole}
                              </span>
                              {answer.respondentId === currentUser?.uid && (
                                <span className="px-1 py-0.5 bg-green-100 text-green-800 text-xs rounded">You</span>
                              )}
                            </div>
                            {answer.answerText && (
                              <p className="text-sm text-gray-700">{answer.answerText}</p>
                            )}
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      );
    }
  };

  const filteredMessages = filterMessages(messages);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader className="h-6 w-6 animate-spin text-teal-500" />
        <span className="ml-2 text-gray-600">Loading chat...</span>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full max-h-screen bg-white rounded-lg border border-gray-200 shadow-sm">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gradient-to-r from-teal-50 to-blue-50">
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-teal-100 rounded-lg">
            <MessageSquare className="h-5 w-5 text-teal-600" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Application Discussion</h2>
            <p className="text-sm text-gray-600">
              {filteredMessages.length} message{filteredMessages.length !== 1 ? 's' : ''}
              {unreadCount > 0 && (
                <span className="ml-2 px-2 py-1 bg-red-100 text-red-800 text-xs rounded-full">
                  {unreadCount} unread
                </span>
              )}
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          {/* Search */}
          <div className="relative">
            <Search className="h-4 w-4 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search messages..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-9 pr-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500 w-48"
            />
          </div>

          {/* Filter */}
          <select
            value={filterUser}
            onChange={(e) => setFilterUser(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
          >
            <option value="all">All Users</option>
            <option value="Hospital">Hospital</option>
            <option value="Doctor">Doctor</option>
            <option value="PolicyWriter">Policy Writer</option>
            <option value="SuperAdmin">Admin</option>
            <option value="Patient">Patient</option>
          </select>
        </div>
      </div>

      {/* Messages */}
      <div className="flex-1 overflow-y-auto p-4 space-y-4 bg-gray-50" style={{ maxHeight: "400px" }}>
        {filteredMessages.length > 0 ? (
          filteredMessages.map((message, index) => {
            const isOwnMessage = message.sender === currentUser?.uid;
            const showAvatar = index === 0 || filteredMessages[index - 1].sender !== message.sender;
            
            return (
              <div key={message.id || `msg_${index}`} className={`flex items-start space-x-3 ${isOwnMessage ? 'flex-row-reverse space-x-reverse' : ''}`}>
                {/* Avatar */}
                {showAvatar && (
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-medium shadow-md ${getUserRoleColor(message.senderRole)}`}>
                    {message.senderName?.charAt(0)?.toUpperCase() || '?'}
                  </div>
                )}
                
                {/* Message Content */}
                <div className={`flex-1 max-w-xs sm:max-w-md lg:max-w-lg ${showAvatar ? '' : 'ml-13'} ${isOwnMessage && showAvatar ? 'mr-13' : ''}`}>
                  {/* Message Header */}
                  {showAvatar && (
                    <div className={`flex items-center space-x-2 mb-2 ${isOwnMessage ? 'justify-end' : ''}`}>
                      <span className="text-sm font-medium text-gray-900">{message.senderName}</span>
                      <span className={`px-2 py-1 text-xs font-medium rounded-full border ${getUserRoleBadge(message.senderRole)}`}>
                        {message.senderRole}
                      </span>
                      <span className="text-xs text-gray-500">{formatTime(message.timestamp)}</span>
                    </div>
                  )}

                  {/* Message Bubble */}
                  <div className={`rounded-lg p-4 shadow-sm ${isOwnMessage ? 'bg-teal-600 text-white' : 'bg-white text-gray-900 border border-gray-200'}`}>
                    {/* Reply indicator */}
                    {message.replyTo && (
                      <div className={`text-xs mb-2 p-2 rounded ${isOwnMessage ? 'bg-teal-700 bg-opacity-50' : 'bg-gray-100'}`}>
                        <Reply className="h-3 w-3 inline mr-1" />
                        <span className="opacity-75">Replying to a message</span>
                      </div>
                    )}

                    {/* Message text */}
                    <p className="text-sm whitespace-pre-wrap break-words">{message.message}</p>

                    {/* File attachments */}
                    {message.attachments && message.attachments.length > 0 && (
                      <div className="mt-3 space-y-2">
                        <p className="text-xs opacity-75 font-medium">Attachments:</p>
                        {message.attachments.map((attachment, idx) => (
                          <div key={idx} className={`flex items-center space-x-2 p-2 rounded-lg border ${isOwnMessage ? 'bg-teal-700 bg-opacity-50 border-teal-500' : 'bg-gray-50 border-gray-200'}`}>
                            <File className="h-4 w-4 flex-shrink-0" />
                            <span className="text-xs flex-1 truncate">{attachment.fileName}</span>
                            <button
                              onClick={() => openDocument(attachment)}
                              className={`text-xs hover:underline flex items-center space-x-1 ${isOwnMessage ? 'text-teal-100' : 'text-teal-600'}`}
                            >
                              <Eye className="h-3 w-3" />
                              <span>View</span>
                            </button>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Q&A Form */}
                    {message.qnaQuestions && message.qnaQuestions.length > 0 && (
                      <div className="mt-4 bg-white rounded-lg p-4 text-gray-900 border border-gray-200">
                        <div className="flex items-center space-x-2 mb-4">
                          <HelpCircle className="h-5 w-5 text-purple-600" />
                          <h4 className="font-semibold text-purple-900">
                            Q&A Form ({message.qnaQuestions.length} question{message.qnaQuestions.length > 1 ? 's' : ''})
                          </h4>
                        </div>
                        
                        <div className="space-y-4">
                          {message.qnaQuestions.map((question, qIdx) => (
                            <div key={question.id || qIdx} className="border border-gray-200 rounded-lg p-4 bg-gray-50">
                              <div className="mb-3">
                                <div className="flex items-start justify-between mb-2">
                                  <p className="font-medium text-gray-900 text-sm">
                                    <span className="text-purple-600 font-semibold">{qIdx + 1}.</span> {question.question}
                                    {question.required && <span className="text-red-600 ml-1">*</span>}
                                  </p>
                                </div>
                                {question.description && (
                                  <p className="text-sm text-gray-600 mb-2">{question.description}</p>
                                )}
                                <div className="flex items-center space-x-2">
                                  {question.required && (
                                    <span className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded-full">Required</span>
                                  )}
                                  <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded-full">
                                    {question.answerType === 'text' ? 'Text Answer' : 
                                     question.answerType === 'file' ? 'File Upload' : 'Text + File'}
                                  </span>
                                </div>
                              </div>

                              {/* Render answer section */}
                              {renderQnAAnswerSection(question, message)}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Message actions */}
                  <div className={`flex items-center space-x-3 mt-2 ${isOwnMessage ? 'justify-end' : ''}`}>
                    <button
                      onClick={() => setReplyingTo(message)}
                      className="text-xs text-gray-500 hover:text-gray-700 flex items-center space-x-1 transition-colors"
                    >
                      <Reply className="h-3 w-3" />
                      <span>Reply</span>
                    </button>
                    <span className="text-xs text-gray-400">{formatDate(message.timestamp)}</span>
                    {!message.readBy?.includes(currentUser?.uid) && message.sender !== currentUser?.uid && (
                      <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="text-center py-12">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <MessageSquare className="h-8 w-8 text-gray-400" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              {searchTerm || filterUser !== "all" ? "No messages found" : "No messages yet"}
            </h3>
            <p className="text-gray-600 max-w-sm mx-auto">
              {searchTerm || filterUser !== "all"
                ? "Try adjusting your search or filter criteria"
                : "Start the conversation by sending a message below"}
            </p>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>

      {/* Message Input Area */}
      <div className="border-t border-gray-200 bg-white p-4">
        {/* Reply indicator */}
        {replyingTo && (
          <div className="bg-blue-50 rounded-lg p-3 mb-4 border-l-4 border-blue-500">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-1">
                  <Reply className="h-4 w-4 text-blue-600" />
                  <span className="text-sm font-medium text-blue-700">Replying to {replyingTo.senderName}</span>
                  <span className={`px-2 py-1 text-xs rounded-full ${getUserRoleBadge(replyingTo.senderRole)}`}>
                    {replyingTo.senderRole}
                  </span>
                </div>
                <p className="text-sm text-blue-600 truncate">
                  {replyingTo.message.length > 100 ? `${replyingTo.message.substring(0, 100)}...` : replyingTo.message}
                </p>
              </div>
              <button onClick={() => setReplyingTo(null)} className="text-blue-400 hover:text-blue-600 p-1">
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>
        )}

        {/* Message Type Selector */}
        <div className="flex items-center space-x-3 mb-4">
          <span className="text-sm font-medium text-gray-700">Message type:</span>
          <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg">
            <button
              onClick={() => { setMessageType("text"); setShowQnAForm(false); }}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-all ${messageType === "text" ? "bg-white text-teal-600 shadow-sm" : "text-gray-600 hover:text-gray-900"}`}
            >
              <Type className="h-4 w-4 inline mr-1" />
              Text
            </button>
            <button
              onClick={() => { setMessageType("file"); setShowQnAForm(false); }}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-all ${messageType === "file" ? "bg-white text-teal-600 shadow-sm" : "text-gray-600 hover:text-gray-900"}`}
            >
              <File className="h-4 w-4 inline mr-1" />
              File
            </button>
            {!disableQna&&(<button
              onClick={() => { setMessageType("qna"); setShowQnAForm(true); }}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-all ${messageType === "qna" ? "bg-white text-teal-600 shadow-sm" : "text-gray-600 hover:text-gray-900"}`}
            >
              <HelpCircle className="h-4 w-4 inline mr-1" />
              Q&A Form
            </button>)}
          </div>
        </div>

        {/* Text/File Message Input */}
        {(messageType === "text" || messageType === "file") && (
          <div className="space-y-3">
            <div className="flex space-x-3">
              <div className="flex-1">
                <div className="flex space-x-2 mb-2">
                  <button
                    onClick={() => setShowStandardQueriesSelector(true)}
                    className="flex items-center space-x-2 px-3 py-2 text-sm bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors"
                  >
                    <FileText className="h-4 w-4" />
                    <span>Standard Queries</span>
                  </button>
                </div>
                <textarea
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  placeholder={messageType === "file" ? "Add description for files (optional)..." : "Type your message..."}
                  rows="3"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 resize-none"
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.preventDefault();
                      handleSendMessage();
                    }
                  }}
                />
              </div>
              <div className="flex flex-col space-y-2">
                {messageType === "file" && (
                  <button
                    onClick={() => fileInputRef.current?.click()}
                    className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 flex items-center space-x-2 transition-colors"
                  >
                    <Upload className="h-4 w-4" />
                    <span>Files</span>
                  </button>
                )}
                <button
                  onClick={handleSendMessage}
                  disabled={
                    actionLoading.sendMessage ||
                    (messageType === "text" && !newMessage.trim()) ||
                    (messageType === "file" && selectedFiles.length === 0)
                  }
                  className="px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2 transition-colors"
                >
                  {actionLoading.sendMessage ? <Loader className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
                  <span>Send</span>
                </button>
              </div>
            </div>

            {/* File Upload Area */}
            {messageType === "file" && (
              <>
                <input ref={fileInputRef} type="file" multiple className="hidden" onChange={handleFileSelect} />
                
                {selectedFiles.length > 0 && (
                  <div className="bg-gray-50 rounded-lg border border-gray-200 p-4">
                    <div className="flex items-center justify-between mb-3">
                      <span className="text-sm font-medium text-gray-700">Selected Files ({selectedFiles.length})</span>
                      {actionLoading.uploadingFiles && (
                        <div className="flex items-center space-x-2 text-blue-600">
                          <Loader className="h-3 w-3 animate-spin" />
                          <span className="text-xs">Uploading...</span>
                        </div>
                      )}
                    </div>
                    <div className="space-y-2">
                      {selectedFiles.map((file, index) => (
                        <div key={index} className="flex items-center justify-between bg-white rounded-lg p-3 border border-gray-200">
                          <div className="flex items-center space-x-3">
                            <File className="h-5 w-5 text-gray-500" />
                            <div>
                              <span className="text-sm text-gray-900 font-medium block">{file.name}</span>
                              <span className="text-xs text-gray-500">{(file.size / 1024).toFixed(1)} KB</span>
                            </div>
                          </div>
                          <button onClick={() => removeSelectedFile(index)} className="text-red-500 hover:text-red-700 p-1">
                            <X className="h-4 w-4" />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        )}

        {/* Q&A Form Builder */}
        {messageType === "qna" && showQnAForm && (
          <div className="bg-gray-50 rounded-lg border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-2">
                <HelpCircle className="h-5 w-5 text-purple-600" />
                <h4 className="text-lg font-semibold text-gray-900">Create Q&A Form</h4>
              </div>
              <button
                onClick={() => { setShowQnAForm(false); setQnaQuestions([]); setMessageType("text"); }}
                className="text-gray-400 hover:text-gray-600 p-1"
              >
                <X className="h-5 w-5" />
              </button>
            </div>

            {/* Existing Questions */}
            {qnaQuestions.length > 0 && (
              <div className="mb-6">
                <h5 className="text-sm font-medium text-gray-700 mb-3">Questions ({qnaQuestions.length})</h5>
                <div className="space-y-3">
                  {qnaQuestions.map((q, index) => (
                    <div key={q.id} className="bg-white rounded-lg p-4 border border-gray-200">
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <div className="flex items-center space-x-2 mb-2">
                            <span className="text-sm font-semibold text-purple-600">Q{index + 1}:</span>
                            {q.required && <span className="px-2 py-1 bg-red-100 text-red-800 text-xs rounded-full">Required</span>}
                            <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">
                              {q.answerType === 'text' ? 'Text' : q.answerType === 'file' ? 'File' : 'Text + File'}
                            </span>
                          </div>
                          <p className="text-gray-900 font-medium text-sm mb-1">{q.question}</p>
                          {q.description && <p className="text-sm text-gray-600">{q.description}</p>}
                        </div>
                        <button onClick={() => removeQuestion(q.id)} className="text-red-600 hover:text-red-800 p-1 ml-3">
                          <Trash2 className="h-4 w-4" />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Add New Question */}
            <div className="border-t border-gray-200 pt-6">
              <h5 className="text-sm font-medium text-gray-700 mb-4">Add New Question</h5>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Question *</label>
                  <textarea
                    value={newQuestion.question}
                    onChange={(e) => setNewQuestion(prev => ({ ...prev, question: e.target.value }))}
                    rows="3"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                    placeholder="Enter your question..."
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Description (Optional)</label>
                  <input
                    type="text"
                    value={newQuestion.description}
                    onChange={(e) => setNewQuestion(prev => ({ ...prev, description: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                    placeholder="Add additional context or instructions..."
                  />
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Answer Type</label>
                      <select
                        value={newQuestion.answerType}
                        onChange={(e) => setNewQuestion(prev => ({ ...prev, answerType: e.target.value }))}
                        className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                      >
                        <option value="text">Text Answer</option>
                        <option value="file">File Upload</option>
                        <option value="both">Text + File</option>
                      </select>
                    </div>

                    <div className="pt-6">
                      <label className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          checked={newQuestion.required}
                          onChange={(e) => setNewQuestion(prev => ({ ...prev, required: e.target.checked }))}
                          className="rounded border-gray-300 text-purple-600 focus:ring-purple-500"
                        />
                        <span className="text-sm text-gray-700">Required</span>
                      </label>
                    </div>
                  </div>

                  <button
                    onClick={handleAddQuestion}
                    disabled={!newQuestion.question.trim()}
                    className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2 transition-colors"
                  >
                    <Plus className="h-4 w-4" />
                    <span>Add Question</span>
                  </button>
                </div>
              </div>
            </div>

            {/* Send Q&A Form */}
            {qnaQuestions.length > 0 && (
              <div className="border-t border-gray-200 pt-6 mt-6">
                <button
                  onClick={handleSendMessage}
                  disabled={actionLoading.sendMessage}
                  className="w-full px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2 transition-colors"
                >
                  {actionLoading.sendMessage ? (
                    <><Loader className="h-5 w-5 animate-spin" /><span>Sending Q&A Form...</span></>
                  ) : (
                    <><HelpCircle className="h-5 w-5" /><span>Send Q&A Form ({qnaQuestions.length} question{qnaQuestions.length > 1 ? 's' : ''})</span></>
                  )}
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Standard Queries Selector Modal */}
      {showStandardQueriesSelector && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
          <div className="w-full max-w-4xl max-h-[90vh] overflow-hidden">
            <StandardQueriesSelector
              onSelectQuery={handleSelectStandardQuery}
              onClose={() => setShowStandardQueriesSelector(false)}
              className="w-full h-full"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DiscussionComponent;